import {
  FindhelpReferralRequest,
  UserInfo
} from '@src/api.types';
import { TMemberInfo } from '@repo/utils';
import { getMemberDetailsFromStorage } from '@src/utills/storage';

export type CustomFormData = {
  advocateFirstName: string;
  advocateLastName: string;
  advocateEmail: string;
  memberFirstName: string;
  memberLastName: string;
  memberEmail: string;
  memberPhone: string;
  programName: string;
  organizationName: string;
  confirmConsent: boolean;
  contactPreferences: string[];
  primaryNeed: string[];
  consent: boolean;
  ConfirmPermission?: boolean;
  pennsylvaniaCoalitionConsent: boolean | null;
};

export function formDataToCustomCBORequest(
  formData: CustomFormData,
  memberInfo: TMemberInfo,
  loggedInAdvocate: UserInfo
): FindhelpReferralRequest {

  // Fetch this to read case_id property
  const memberDetails = getMemberDetailsFromStorage();
  const primaryNeedsArray = Array.isArray(formData.primaryNeed)
    ? formData.primaryNeed
    : [formData.primaryNeed];

  return {
    programDetails: {
      programName: formData.programName || '',
      programOrgName: formData.organizationName,
      programAddr1: '',
      programAddr2: null,
      programCity: '',
      programState: '',
      programZipcode: '',
      programPhone: '',
      programEmail: '',
    },
    memberId: memberInfo.member_id,
    programId: "CUSTOM_CBO",
    receiverEmail: formData.memberEmail,
    receiverFirstName: formData.memberFirstName,
    receiverLastName: formData.memberLastName,
    receiverPhone: formData.memberPhone,
    receiverDateOfBirth: memberInfo.DOB,
    receiverZip: memberInfo.zipCode,
    contactPreferences: [],
    comment: null,
    senderEmail: formData.advocateEmail,
    caseId: memberDetails?.case_id ?? null,
    selectedNeeds: {
      primaryNeeds: primaryNeedsArray,
      secondaryNeeds: [],
    },
    consumerId: memberInfo.ConsumerId ?? '',
    lineOfBusiness: memberInfo.lineOfBusiness,
    consent: formData.consent,
    senderSecureRoles: loggedInAdvocate.roles.join(', '),
    medSup: memberInfo.medSup ?? false,
    gender: memberInfo.gender,
    stateCode: memberInfo.address?.state,
    address: memberInfo.address,
    enterpriseIndividual: memberInfo.enterpriseIndividualIdentifier,
    coalition_consent: formData.pennsylvaniaCoalitionConsent,
  };
}